import { AlertMessage, Button, CommonModal, CoreLoader } from "common/components";
import ConfirmationModal from "common/components/ConfirmationModal";
import apiManager from "networking/baseAPIManager";
import React, { useEffect, useState } from "react";

const AdvanceSalaryView = ({ Data, setOpen, fetchapi }) => {
  const [loading, setLoading] = useState(false);
  const [showMSG, setShowMSG] = useState(false);
  const [msgType, setmsgType] = useState("info");
  const [cancele_id, setCancel_id] = useState("");
  const [confirm, setConfirm] = useState(false);
  const [WithdrawModalOpen, setWithdrawModalOpen] = useState(false);

  let BASE_URL = process.env.REACT_APP_BASE_URL;
  const employeeInfo = Data;
  const moment = require("moment");
  const formatDate = (date) => moment(date).format("DD MMM YYYY");
  const secLabels = {
    employee_name: "Employee Name",
    employeeID: "Employee ID",
    createdAt: "Applied Date",
    amount: "Amount",
    model: "Duration",
    instalment: "Installment",
  };

  const openWithdrawModal = () => {
    setWithdrawModalOpen(true);
    setCancel_id(Data._id);
  };

  const handleStatusChange = () => {
    let dataPayload = {
      id: cancele_id,
      status: "cancelled",
    };
    setLoading(true);
    apiManager
      .advanceSalaryStatus(dataPayload)
      .then((res) => {
        setLoading(false);
        fetchapi && fetchapi();
        setmsgType("success");
        setShowMSG(res?.data?.message || "details updated successfully");
      })
      .catch((err) => {
        setLoading(false);
        setmsgType("error");
        setShowMSG(err?.response?.data?.message || "failed to update");
      });
  };

  const arr = employeeInfo
    ? Object.entries(employeeInfo)
        .filter(([originalLabel]) => secLabels[originalLabel])
        .map(([originalLabel, value]) => ({
          label: secLabels[originalLabel],
          value: value,
        }))
    : [];
  useEffect(() => {
    if (confirm) {
      handleStatusChange();
      setConfirm(false);
    }
  }, [confirm]);

  return (
    <div className="container">
      {/* <AlertMessage show={showMSG} setShow={setShowMSG} type={msgType} /> */}
      <div className="row">
        <div className="col-lg-6">
          <div className="row">
            {employeeInfo ? (
              <>
                <div className="col-lg-12 ps-5">
                  <img
                    src={`${BASE_URL}/${employeeInfo.image}`}
                    alt="Asset"
                    width="200"
                    height="200"
                    className="rounded-circle"
                  />
                </div>
                <div className="col-lg-12">
                  <ul>
                    <li className="row">
                      <span className="col-lg-6 pt-4">Status </span>
                      <span className="col-lg-6 text-dark-emphasis pt-3">{employeeInfo.status}</span>
                    </li>
                    <li className="row">
                      <span className="col-lg-6 pt-4">Salary Type</span>
                      <span className="col-lg-6 text-dark-emphasis pt-3">{employeeInfo.advance_salary_type}</span>
                    </li>
                    <li className="row">
                      <span className="col-lg-6 pt-4">Reson </span>
                      <span className="col-lg-6 text-dark-emphasis pt-3">{employeeInfo.reason}</span>
                    </li>
                  </ul>
                </div>
              </>
            ) : null}
          </div>
        </div>
        <div className="col-lg-6 pt-3">
          {arr &&
            arr.map((content, index) => (
              <div className="row " key={index}>
                <div className="col-lg-6 pt-4  ">{content.label} </div>
                <div className="col-lg-6 pt-4 text-dark-emphasis ">{content.value}</div>
              </div>
            ))}
        </div>
      </div>

      {Data && Data.status === "approved" && (
        <div className="row px-5">
          <div className="col-md-10 p-2"></div>
          <div className="col-md-2 p-2">
            <Button label="withdraw" onClick={() => openWithdrawModal()}></Button>
          </div>

          {WithdrawModalOpen && (
            <div className="col-md-12 drawpop p-2">
              <ConfirmationModal setOpen={setOpen} setConfirm={setConfirm} />
            </div>
          )}
          <CoreLoader show={loading} disableLines />
        </div>
      )}
    </div>
  );
};

export default AdvanceSalaryView;
